// extracted by mini-css-extract-plugin
export default {"menu":"widgets-contacts-and-settings-fields-Phone-PhoneFieldDetails__menu--h1ObF"};